import registerExtension from './register-extension';
import updateExtension from './update-extension';

export default {
  registerExtension,
  updateExtension,
};
